<script lang="ts">
  import type { ApiField } from '../../data-tables-api';
  import RelationPicker from '../RelationPicker.svelte';

  let {
    field,
    value,
    onChange,
    error,
    disabled = false,
  }: {
    field: ApiField;
    value: unknown;
    onChange: (v: unknown) => void;
    error?: string | null;
    disabled?: boolean;
  } = $props();

  const slug = $derived(field.target_slug ?? null);
  const stringValue = $derived(value != null ? String(value) : '');
</script>

{#if !slug}
  <!-- Без цільової таблиці picker неможливий — fallback на ручний UUID. -->
  <input
    type="text"
    value={stringValue}
    oninput={(e) => onChange((e.target as HTMLInputElement).value || null)}
    placeholder="UUID запису"
    {disabled}
    class="w-full rounded-md border px-3 py-2 text-sm font-mono {error ? 'border-red-400' : 'border-[var(--color-border-3)]'}"
  />
  <div class="mt-1 text-[10.5px] text-amber-700">Цільова таблиця не задана.</div>
{:else}
  <RelationPicker {slug} cardinality={field.cardinality ?? 'one'} {value} {onChange} {disabled} />
{/if}

{#if error}
  <div class="mt-1 text-[11px] text-red-600">{error}</div>
{/if}
